import { EventEngineEventsService } from '@amzn/event-engine-events-sdk';
import { useLazyRequest } from '@amzn/event-engine-js-utils';
import { AWSError } from 'aws-sdk/lib/error';
import { useNotification } from 'hooks';
import React, { FC, useCallback, useEffect, useState } from 'react';
import EEEvents from 'services/ee-events';
import ErrorMessage from 'services/error-message';
import { i18nStrings } from 'utils/constants';

import LinkAsync from './LinkAsync';
import SshKeyPairModal from './SshKeyPairModal';

export interface TeamSshKeyLinkProps {
    participantId: string;
}

const TeamSshKeyLink: FC<TeamSshKeyLinkProps> = ({ participantId }) => {
    const [
        sshKeyPair,
        setSshKeyPair,
    ] = useState<EventEngineEventsService.ParticipantGetTeamSshKeyPairResponse>();
    const { showNotification, clearNotification } = useNotification();
    const [
        getParticipantTeamSshKeyPair,
        {
            data: participantTeamSshKeyPairData,
            isLoading: participantTeamSshKeyPairLoading,
            isError: participantTeamSshKeyPairError,
        },
    ] = useLazyRequest<typeof EEEvents.getParticipantTeamSshKeyPair, AWSError>(
        EEEvents.getParticipantTeamSshKeyPair,
        {}
    );
    const getTeamSshKeyPair = useCallback(() => {
        !participantTeamSshKeyPairLoading &&
            getParticipantTeamSshKeyPair(participantId);
    }, [participantTeamSshKeyPairLoading]);
    const onSshKeyPairModalDismiss = useCallback(() => {
        setSshKeyPair(undefined);
    }, []);

    useEffect(() => {
        participantTeamSshKeyPairData &&
            setSshKeyPair(participantTeamSshKeyPairData);
    }, [participantTeamSshKeyPairData]);

    useEffect(() => {
        participantTeamSshKeyPairError &&
            showNotification(
                ErrorMessage.getMessage(participantTeamSshKeyPairError),
                { type: 'error' }
            );
    }, [participantTeamSshKeyPairError]);

    useEffect(() => {
        return () => {
            clearNotification();
        };
    }, []);

    return (
        <>
            <LinkAsync
                onFollow={getTeamSshKeyPair}
                loading={participantTeamSshKeyPairLoading}>
                {i18nStrings.event.getEC2SshKey}
            </LinkAsync>
            {sshKeyPair && (
                <SshKeyPairModal
                    visible={!!sshKeyPair}
                    onDismiss={onSshKeyPairModalDismiss}
                    data={sshKeyPair}
                />
            )}
        </>
    );
};

export default TeamSshKeyLink;
